import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { EmbedLogo as i } from "../Embed/EmbedLogo.js";
function l({ onCloseButtonClick: n }) {
  return /* @__PURE__ */ t("div", { className: "flex min-h-6 shrink-0 items-start justify-between", children: [
    /* @__PURE__ */ e("div", { className: "w-11 min-[409px]:max-[409px]:hidden" }),
    /* @__PURE__ */ e(i, {}),
    /* @__PURE__ */ e("div", { className: "w-11 min-[409px]:max-[409px]:hidden", children: /* @__PURE__ */ e(r, { onCloseButtonClick: n }) })
  ] });
}
function r({ onCloseButtonClick: n }) {
  return /* @__PURE__ */ e(
    "button",
    {
      className: "mr-1 mt-1 flex h-10 w-10 items-center justify-center rounded-small bg-background text-foreground transition-all hover:bg-accent focus-visible:text-accent-foreground focus-visible:ring-1 focus-visible:ring-ring",
      onClick: n,
      children: /* @__PURE__ */ e(
        "svg",
        {
          className: "h-6 w-6",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ e(
            "path",
            {
              strokeLinecap: "butt",
              strokeLinejoin: "round",
              strokeWidth: "2",
              d: "M6 18L18 6M6 6l12 12"
            }
          )
        }
      )
    }
  );
}
export {
  l as EmbedPopupHeader
};
